// extracted by mini-css-extract-plugin
export default {"Icon":"Icon_Icon__176E0","Icon_size_small":"Icon_Icon_size_small__EXa3I","Icon_size_medium":"Icon_Icon_size_medium__a8B6u","Icon_size_large":"Icon_Icon_size_large__qSek5"};